<app-user-message *ngIf="loadError" type="error" [title]="globalService.Get('CONNECTION_ERROR')" [message]="globalService.Get('CHECK_YOUR_CONNECTION_AND_TRY_AGAIN')" [actionLabel]="globalService.Get('TRY_AGAIN')" [busy]="isLoading" [dismissible]="false" (action)="retryLoad()"></app-user-message>
<div class="row" [attr.aria-busy]="isLoading">
  <div
    class="form-group col-12"
    [class.text-right]="globalService.isRTL == true"
  >
    <label for="startDate">{{ globalService.Get("SELECTDATE") }}</label>
    <div>
      <div class="input-group">
        <input
          id="startDate"
          name="startDate"
          class="form-control"
          matInput
          [matDatepicker]="startDate"
          [ngModel]="myStartDate"
          required [disabled]="AutoMode || isLoading"
          (click)="globalService.OpenCalendar(startDate)"
          (dateChange)="DateChange($event)"
        />
        <mat-datepicker
          [touchUi]="(globalService.isHandset$ | async) ? 'true' : 'false'"
          #startDate
        ></mat-datepicker>
        <div class="input-group-append">
          <button
            type="button"
            
            class="btn btn-secondary btn-small input-group-text"
            (click)="globalService.OpenCalendar(startDate)"
          >
            <span>
              <i class="fas fa-calendar-alt"></i>
            </span>
          </button>
        </div>
      </div> 
    </div>

    <div class="row mt-3" [class.text-right]="globalService.isRTL == true">
      <div class="form-group col-12 col-sm-6 col-lg-6">
        <label for="groupId">{{ globalService.Get("SERVICE") }}</label>
        <select #groupSelect id="groupId" class="form-control" [class.classicRTL]="globalService.isRTL == true"
          [class.classic]="globalService.isRTL == false" name="groupId" [ngModel]="eventGroupId" [disabled]="AutoMode || isLoading"
          (change)="onGroupChanged(groupSelect.value)">
          <!-- <option [ngValue]="null" disabled="" style="display: none">
            Choose Category
          </option> -->
          <option [ngValue]="0">
            {{ globalService.Get("ALL_SERVICES") }}
          </option>          
          <option *ngFor="let group of groupArr" [value]="group.id">
            {{ group.name }}
          </option>
        </select>
      </div> 
      <div class="form-group col-12 col-sm-6 col-lg-6">
        <label for="venueId"> {{ globalService.Get("LOCATION") }}</label>
        <select #venueSelect id="venueId" class="form-control" [class.classicRTL]="globalService.isRTL == true" [disabled]="AutoMode || isLoading"
        [ngModel]="eventVenueId"
          [class.classic]="globalService.isRTL == false" name="venueId"
          (change)="onVenueChanged(venueSelect.value)">
          <!-- <option [ngValue]="null" disabled="" style="display: none">
            Choose Venue
          </option> -->
          <option [ngValue]="0">
            {{ globalService.Get("ALL_LOCATIONS") }}
          </option>          
          <option *ngFor="let venue of venueArr" [value]="venue.id">
            {{ venue.name }}
          </option>
        </select>
      </div>
      <hr />
    </div>    
  </div>
</div>
